import { processAccessControlError } from "actions/access-control-actions";
import { AccessControl, ICompany } from "components/contacts/contacts-types";
import { getStore } from "store";

interface IError {
    code: number;
    message: string;
}

export const ACCESS_CONTROL_ERROR = {
    CODE: 403,
    MESSAGE: "Access to brand revoked",
};

export const FALLBACK_PAGE = "/dashboard";
export const BRAND_PAGE = "/brand";
export const ASSORTMENT_PAGE = "/assortment";

export const hasCompanyAccess = (company: Pick<ICompany, "access_control">) =>
    (company?.access_control ?? AccessControl.FullAccess) === AccessControl.FullAccess;

export const hasBrandCompanyAccess = ({
    useCompanyAccessControl,
    company,
}: {
    useCompanyAccessControl: boolean;
    company: Pick<ICompany, "access_control">;
}) => {
    return !useCompanyAccessControl || hasCompanyAccess(company);
};

export const isAccessControlError = (error: IError) => {
    return error?.code === ACCESS_CONTROL_ERROR.CODE && error?.message === ACCESS_CONTROL_ERROR.MESSAGE;
};

export const checkAccessControlError = ({ error, brandName }: { error: IError; brandName?: string }) => {
    if (isAccessControlError(error)) {
        getStore().dispatch(processAccessControlError({ brandName }));
    }
};

export const hasPaymentProcessorByName = (gateway_name: string, scope): boolean => {
    const paymentsEnabled = scope.brand?.modules?.payments?.enabled;
    const hasProcessor = scope.brand?.modules?.payments?.accounts.some((account) => {
        const isProcessor = account.detail.gateway_name === gateway_name;
        const isActive = ["done", "pending", "active"].includes(account.detail.status);

        return isProcessor && isActive;
    });
    const hasPaymentAccounts = hasProcessor && paymentsEnabled;
    return hasPaymentAccounts;
};
